/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { SiteList, SiteDetails } from './components';

export const Sites = () => {
  return (
    <Routes>
      <Route path="/" element={<SiteList />} />
      <Route path="/:domain" element={<SiteDetails />} />
    </Routes>
  );
};
